import {
  Directive,
  ElementRef,
  OnInit,
  Renderer2,
  inject,
} from '@angular/core';

/**
 * Directive to prevent the autofill on browsers
 * creating hidden inputs that recieves the autocomplete of the browser
 */
@Directive({
  selector: '[appPreventAutoFill]',
  standalone: true,
})
export class PreventAutoFillDirective implements OnInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngOnInit() {
    // Add hidden email input
    const emailInput = this.renderer.createElement('input');
    this.renderer.setAttribute(emailInput, 'type', 'text');
    this.renderer.setAttribute(emailInput, 'autocomplete', 'email');
    this.renderer.setStyle(emailInput, 'display', 'none');
    this.renderer.appendChild(this.el.nativeElement, emailInput);

    // Add hidden password input
    const passwordInput = this.renderer.createElement('input');
    this.renderer.setAttribute(passwordInput, 'type', 'password');
    this.renderer.setAttribute(passwordInput, 'autocomplete', 'new-password');
    this.renderer.setStyle(passwordInput, 'display', 'none');
    this.renderer.appendChild(this.el.nativeElement, passwordInput);
  }
}
